<template>
    <div class="container LoanContract" v-if="isVisible" style="z-index:1;">
        <div class="LoanContractDialog">
            <el-row>
                <el-col :span="24">
                    <div class="LoanContractHeader">
                        <div class="LoanContractHeaderName"></div>
                        <div class="LoanContractHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="推荐函" name="first">
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractCode"><el-input v-model="model.Hjhbh" placeholder="" style="width:350px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractTitle">推荐函</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFrom"><el-input v-model="model.Title" placeholder="" style="width:500px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractContent2">为进一步推动农业信贷服务体系创新,有效缓解我市新型农业经营主体和服务主体“融资难、融资贵”,根据湖北省农业信贷融资担保有限公司与枝江市人民政府合作协议,经枝江市天雨农业融资担保有限公司审核评审、以下借款人符合基本准入条件，同意向省农业信贷担保有限公司推荐,续贷担保金额以贷款结清后重新出具推荐函为准。请予接洽办理。</div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">借款人名称:</label><div class="LoanContractContent"><el-input v-model="model.Jkrmc" placeholder="" style="width:400px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">借款人(或法人）:</label><div class="LoanContractContent"><el-input v-model="model.Jkr" placeholder="" style="width:100px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">身份证号:</label><div class="LoanContractContent"><el-input v-model="model.Sfzh" placeholder="" style="width:250px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">推荐金额:{{model.Tjjedx}}万元（￥</label><div class="LoanContractContent"><el-input v-model="model.Tjje" placeholder="" style="width:80px;" @change="onMoneyChange"></el-input>万元)</div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">期限:</label><div class="LoanContractContent"><el-input v-model="model.Qx" placeholder="" style="width:80px;"></el-input>年</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractSplit"></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">枝江市天雨农业融资担保有限公司</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">
                                <el-date-picker
                                    value-format="YYYY-MM-DD"
                                    v-model="model.Sj"
                                    format="YYYY年MM月DD日"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractOperate">
                                <el-button size="medium" type="info" @click="onExportWord(1)">导出预览推荐函</el-button>
                                <el-button size="medium" type="success" @click="onSubmit(1)">确认生成担保函</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="担保函" name="second">
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractCode"><el-input v-model="model2.Hjhbh" placeholder="" style="width:350px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractTitle">担保函</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFrom"><el-input v-model="model2.Title" placeholder="" style="width:500px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractContent2">根据<el-input v-model="model2.Jkrmc" placeholder="" style="width:300px;text-indent:0px;"></el-input>提出的担保贷款申请,经我公司调查、评审并与贷款人办妥相关手续,枝江市天雨农业融资担保有限公司同意为该经营主体进行担保,担保贷款金额人民币{{model2.Tjjedx}}万元（￥:<el-input v-model="model2.Tjje" placeholder="" style="width:80px;text-indent:0px;" @change="onMoneyChange2"></el-input>万元）,期限<el-input v-model="model2.Qx" placeholder="" style="width:80px;text-indent:0px;"></el-input>个月（具体时间以借款凭证为准),请贵行为借款人发放贷款。</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractSplit"></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">枝江市天雨农业融资担保有限公司</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">
                                <el-date-picker
                                    value-format="YYYY-MM-DD"
                                    v-model="model2.Sj"
                                    format="YYYY年MM月DD日"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractOperate">
                                <el-button size="medium" type="info" @click="onExportWord(2)">导出预览担保函</el-button>
                                <el-button size="medium" type="success" @click="onSubmit(2)">确认生成担保函</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
            
        </div>
    </div>
   
</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);
</style>
